import request from '@/config/axios'


// 菜单列表
export const PermissionMenuList=(data:any)=>{
    return request.get({ url: '/admin/group/getMenu ', data })
  }

// 菜单列表详情
export const menuPermissionInfo=(data:any)=>{
  return request.get({ url: `/admin/group/menuPermission?menu_id=${data}` })
}

// 权限项列表
export const permissionItemList=()=>{
  return request.post({ url: `/admin/group/permissionList`, data: {} })
}

// 添加权限
export const addPermissionInfo=(data:any)=>{
  return request.post({ url: `/admin/group/setPermission`,data })
}

// 编辑权限
export const editPermissionInfo=(data:any)=>{
  return request.post({ url: `/admin/group/updatePermission`,data })
}

// 删除权限
export const delPermissionInfo=(data:any)=>{
  return request.post({ url: `/admin/group/deletePermission`,data })
}

// 获取权限
export const getPermission=(data:any)=>{
  return request.get({ url: `/admin/group/havePermission`})
}

// ** 用户管理 **********************************************************************************
// 获取 本部公司 列表 数据
export const getCompanyList=(data:any)=>{
  return request.post({ url: `/admin/head/companyList`,data })
}

// 本部公司 保存 
export const companySave=(data:any)=>{
  return request.post({ url: `/admin/head/companySave`,data })
}

// 本部公司 信息
export const getCompanyInfo=(data:any)=>{
  return request.post({ url: `/admin/head/companyInfo`,data })
}

// 生成飞鱼内部进入商家后台短期访问令牌
export const companyVisitToken=(data:any)=>{
  return request.post({ url: `/admin/head/companyVisitToken`,data })
}

// 用户数据-用户分值 列表 数据 
export const getCompanyServiceScoreList=(data:any)=>{
  return request.post({ url: `/admin/head/companyServiceScore`,data })
}

// 用户数据-维护计划 列表 数据 
export const getCompanyMaintenanceList=(data:any)=>{
  return request.post({ url: `/admin/head/companyMaintenanceList`,data })
}

// 用户数据-维护计划 保存 接口
export const companyMaintenanceSave=(data:any)=>{
  return request.post({ url: `/admin/head/companyMaintenanceSave`,data })
}


// ** 参数设置 **********************************************************************************
// 获取 分值参数 列表 数据
export const getServiceScoreConfig=(data:any)=>{
  return request.post({ url: `/admin/head/serviceScoreConfig`,data })
}

// 分值参数 保存 接口 
export const setServiceScoreConfig=(data:any)=>{
  return request.post({ url: `/admin/head/serviceScoreConfigSave`,data })
}

// 看板参数 保存 接口 
export const companyConfigSave=(data:any)=>{
  return request.post({ url: `/admin/head/companyConfigSave`,data })
}
